export default "__VITE_ASSET__8729vGzi__"